import type { CoreApi } from '~/services-v2/core-api/core-api.http.types'
import type { PersonService } from '~/services-v2/person-api/person-api.types'
import type { GtmEventName, GtmUserProperties } from '~/types/analytics'

/**
 * Partner linked to the logged user: core first, person-api as fallback.
 */
export function getPartnerId(
  me?: CoreApi.MeResponse['data'],
  person?: PersonService.User,
): string | undefined {
  return me?.parceiro?.id?.toString() ?? person?.partner?.id?.toString()
}

/**
 * Pushes only `user_properties` to the dataLayer (no event).
 * Used on app init so GTM native events (page_view) already have context.
 */
export function setUserProperties(props: GtmUserProperties): void {
  if (typeof window === 'undefined')
    return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ user_properties: props })
}

/**
 * Pushes a custom event + user_properties to the dataLayer.
 */
export function pushToDataLayer(
  event: GtmEventName,
  userProperties: GtmUserProperties,
  eventParams: Record<string, unknown> = {},
): void {
  if (typeof window === 'undefined')
    return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    user_properties: userProperties,
    ...eventParams,
  })
}
